<template>

        <email-editor :project="project"
                      :selected-sub-panels="selectedSubPanels"
                      @change:translations="translationsChanged"
                      template="project-invitation">
        </email-editor>

</template>

<script>

import Json from 'vue-json-pretty';
import EmailEditor from "../EmailEditor";

export default {

    components: {
        Json,
        EmailEditor
    },

    props: {
        project: {
            type: Object,
            required: true,
        },
        selectedSubPanels: {
            type: Array,
            required: true,
        }
    },

    methods: {
        translationsChanged(translations) {
            this.$emit('change:translations', translations);
        }
    }
}
</script>
